<template>
  <section class="redirect">
    <Heading :level="3">
      Pronto {{ firstName }}. Você acabou de criar sua conta de acesso na Warren
    </Heading>
    <BaseText
      v-if="isMobile"
      class="redirect-text"
      size="p4"
      :color="NebraskaColors.elementSecondary"
    >
      Baixe o aplicativo da Warren, clique em <strong>acessar conta</strong> e
      faça login com o e-mail e a senha que você definiu agora.
    </BaseText>
    <BaseText
      v-else
      class="redirect-text"
      size="p4"
      :color="NebraskaColors.elementSecondary"
    >
      Siga as instruções abaixo para finalizar o seu cadastro.
    </BaseText>
    <Link v-if="isMobile" :href="href">
      <ButtonPrimary
        class="redirect-button"
        label="Baixar aplicativo"
        size="large"
        type="submit"
      />
    </Link>
    <div v-else class="redirect__container">
      <div class="redirect__container-steps">
        <div class="redirect__container-step">
          <BaseText size="p5" :color="NebraskaColors.elementPrimary">
            1
          </BaseText>
          <BaseText size="p4" :color="NebraskaColors.elementSecondary">
            Aponte para o QR Code <br />com a câmera do seu celular.
          </BaseText>
        </div>
        <div class="redirect__container-step">
          <BaseText size="p5" :color="NebraskaColors.elementPrimary">
            2
          </BaseText>
          <BaseText size="p4" :color="NebraskaColors.elementSecondary">
            Instale o app da Warren.
          </BaseText>
        </div>
        <div class="redirect__container-step">
          <BaseText size="p5" :color="NebraskaColors.elementPrimary">
            3
          </BaseText>
          <BaseText size="p4" :color="NebraskaColors.elementSecondary">
            No aplicativo, clique em <strong>acessar conta</strong> e faça login
            com o e-mail<br />
            e a senha que você definiu agora.
          </BaseText>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import {
  Heading,
  BaseText,
  Link,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { Ref, computed, inject, onMounted, ref } from 'vue';
import { Advisor } from '@/modules/onboarding/signup/types';
import { trackQrCodeView } from '@/modules/onboarding/signup/helpers/track-events';

const firstName = inject('firstName');
const storeHref = ref('');
const userHaveAdvisor = inject('userHaveAdvisor') as Ref<boolean>;
const advisor = inject('advisor') as Ref<Advisor>;
const isMobile = inject('isMobile') as Ref<boolean>;

const appStoreLink =
  'https://apps.apple.com/br/app/warren-investimentos/id1114394063';
const playStoreLink = advisor.value?.email
  ? `https://play.google.com/store/apps/details?id=com.oiwarren.oiwarren&referrer=utm_source${encodeURIComponent(
      `=${advisor.value?.email}`
    )}`
  : 'https://play.google.com/store/apps/details?id=com.oiwarren.oiwarren';

const href = computed(() => {
  return navigator.userAgent.includes('iPhone') ||
    navigator.userAgent.includes('iPad')
    ? appStoreLink
    : playStoreLink;
});

function mountStoreHref() {
  const currentUrl = window.location.href;
  const baseUrl = currentUrl.split('/#/')[0];
  storeHref.value = userHaveAdvisor.value
    ? `${baseUrl}/#/mobile?advisor=${advisor.value?.email}`
    : `${baseUrl}/#/mobile`;
}

onMounted(() => {
  mountStoreHref();
  trackQrCodeView();
});
</script>
<style lang="less" scoped>
.redirect {
  &-text {
    margin-top: @size-spacing-x350;
  }

  &-button {
    width: 100%;
    margin-top: @size-spacing-x500;
  }

  &__container {
    display: flex;
    margin-top: @size-spacing-x600;
    justify-content: space-between;

    &-steps {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: @size-spacing-x300;
      margin-right: @size-spacing-x500;
    }

    &-step {
      display: flex;
      align-items: flex-start;
      gap: @size-spacing-x350;
    }
  }
}
</style>
